import React from 'react';
import './index.css'
import { Form } from 'react-bootstrap';
import Text from '../Text';
import MainStyles from '../../styles/MainStyles'


const FormGroup = ({labelText, _style, controlId, isActive, children, required, hideLabel}) => {
    let ownClass = _style ? _style : ''

    const createPlaceholder = () => {
        return required && !isActive ? labelText + '*' : labelText
    }
    return (
        <Form.Group className={ownClass} required={required} controlId={controlId}>
            { !hideLabel && <Form.Label className={isActive ? 'field-active' : ''}>
                <Text text={createPlaceholder()} size={'little'} color={MainStyles.colors.white}/>
            </Form.Label> }
            {children}
        </Form.Group>
    )
}

export default FormGroup;